import { connect } from 'react-redux';
import SideBar from './SideBar';
import { actions } from './SideBar.actions';
import { getLocationPathname } from '../../utils/locationUtils';

// Note: `list` (navigation items) is NOT passed from here.
// SideBar.js reads navigation directly from TemplateConfigContext,
// which is the single source of truth for template-specific sidebar structure.
const SideBarComponent = connect(
    function mapStateToProps(state) {
        return {
            isNavExtended: state.isNavExtended,
            location: getLocationPathname(state),
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            toggleNav: actions.toggleNav
        };
    }
)(SideBar);

export default SideBarComponent;
